import {
	loginRequestBlockButtonsBoxSX,
	loginRequestBlockButtonSX,
	loginRequestBlockPaperSX,
	loginRequestBlockTextSX,
} from '@/components/blocks/LoginRequestBlock/styles/loginRequestBlockStyles';
import { useSessionDialog } from '@/data/Content/SessionDialog';
import { useLocalization } from '@/data/Localization';
import { useUser } from '@/data/User';
import { logEvent } from '@/data/utils/logEventsUtils';
import { useMobileApp } from '@/utils/useMobileApp';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

type Props = {
	panelText: string;
	classProp?: string;
	signInId?: string;
	registerId?: string;
	onActionClick?: () => void;
};

export const LoginRequestBlock: FC<Props> = ({
	panelText,
	classProp,
	signInId,
	registerId,
	onActionClick,
}) => {
	const theme = useTheme();
	const { openSessionDialog } = useSessionDialog();
	const panelLabels = useLocalization('SignInRegisterPanel');
	const { user } = useUser();
	const { isMobileApp } = useMobileApp();

	const openLoginModal = () => {
		if (!user?.isLoggedIn) openSessionDialog('signIn');
		onActionClick?.();
	};
	const openRegisterModal = (e: React.MouseEvent) => {
		if (isMobileApp) {
			e.preventDefault();
			logEvent('onRegisterClick');
		} else if (!user?.isLoggedIn) {
			openSessionDialog('register');
		}
		onActionClick?.();
	};

	return (
		<Box sx={loginRequestBlockPaperSX(theme)}>
			<Typography variant="body1" sx={loginRequestBlockTextSX}>
				{panelText}
			</Typography>
			<Box sx={loginRequestBlockButtonsBoxSX}>
				<Button
					id={signInId}
					sx={loginRequestBlockButtonSX}
					variant="contained"
					onClick={openLoginModal}
					className={classProp ? `${classProp}__login` : undefined}
				>
					{panelLabels.Actions.LogIn.t()}
				</Button>
				<Button
					id={registerId}
					sx={loginRequestBlockButtonSX}
					variant="outlined"
					onClick={openRegisterModal}
					className={classProp ? `${classProp}__register` : undefined}
				>
					{panelLabels.Actions.CreateAccount.t()}
				</Button>
			</Box>
		</Box>
	);
};
